/**
 * Created by Ning Jiang on 2022-02-18.
 */

import {SerialReelView} from "./SerialReelView";
import {Layers, SerialLayers} from "../view/SerialLayers";
import {ReelPositionController} from "./ReelPositionController";
import {MultiSprites} from "@nolimitcity/slot-game/bin/animation/MultiSprites";
import {Serial} from "../Serial";

export class EnhancerReelView extends SerialReelView {

    public readonly defaultHeight:number = ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5;
    protected readonly _reelLock:MultiSprites

    constructor(reelId:number, positionId:number, initHeight:number) {
        super(reelId, positionId, initHeight);

        this._reelLock = new MultiSprites();
        this.initLock(reelId);
        this._reelLock.position.set(ReelPositionController.REEL_AREAS[reelId].x, this.currentTop + ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.25);
        SerialLayers.getLayer(Layers.REEL_LOCK)?.addChild(this._reelLock);
    }

    protected initLock(reelId:number):void {
        this._reelLock.addSprites(
            {
                name : "open",
                textures : Serial.assetLoader.getTextures(reelId === 4 ? "enhancer/Enhancer5Open/Enhancer5Open_" : "enhancer/EnhancerOpen/EnhancerOpen_"),
                anchor : new PIXI.Point(0.5, 0.5)
            },
            {
                name : "close",
                textures : Serial.assetLoader.getTextures(reelId === 4 ? "enhancer/Enhancer5Close/Enhancer5Close_" : "enhancer/EnhancerClose/EnhancerClose_"),
                anchor : new PIXI.Point(0.5, 0.5)
            }
        );
    }

    public setOpened(value:boolean):void {
        this._reelLock.playSprite(value ? "open" : "close", {duration : 0.1, alpha : 1}, {duration : 0.1, alpha : 0});
    }

    public resetPosition(top:number) {
        super.resetPosition(top);
        this._reelLock.position.y = this.currentTop + ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.25;
    }

    public resetHeight(height?:number) {
        if(height == null) {
            height = this.currentHeight;
        }

        if(height === 0) {
            this.currentHeight = 0;
            this._lowContainer.visible = false;
            this._highContainer.visible = false;
            this._lowWinContainer.visible = false;
            this._highWinContainer.visible = false;
            this._reelLock.visible = false;
            return;
        }

        super.resetHeight(height);
        this._lowContainer.visible = true;
        this._highContainer.visible = true;
        this._lowWinContainer.visible = true;
        this._highWinContainer.visible = true;
        this._reelLock.visible = height === this.defaultHeight;
    }

    public getSymbolHeight():number {
        return ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5;
    }
}